import { Font, pdf } from '@react-pdf/renderer'

import faRegular from '/fonts/fa-regular-400.ttf'
import faSolid from '/fonts/fa-solid-900.ttf'
import notoBold from '/fonts/NotoSans-Bold.ttf'
import notoRegular from '/fonts/NotoSans-Regular.ttf'
import openSansBold from '/fonts/OpenSans-Bold.ttf'
import openSansRegular from '/fonts/OpenSans-Regular.ttf'
import soraRegular from '/fonts/Sora-Regular.ttf'

Font.register({
  family: 'NotoSans',
    fonts: [
    { src: notoRegular, fontWeight: 'normal' },
    { src: notoBold, fontWeight: 'bold' },
  ],
})

Font.register({
  family: 'OpenSans',
  fonts: [
    { src: openSansRegular, fontWeight: 'normal' },
    { src: openSansBold, fontWeight: 'bold' }
  ]
})

Font.register({
  family: 'Sora',
  fonts: [
    { src: soraRegular, fontWeight: 'normal' },
  ]
})

Font.register({ family: 'FA-REG', src: faRegular })

Font.register({ family: 'FA-SLD', src: faSolid })

Font.registerHyphenationCallback((word) => {
  return [word]
})

export const downloadBlob = async (jsxElement: JSX.Element, filename: string) => {
  const blob = await pdf(jsxElement).toBlob()
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')

  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

export const previewBlob = async (
  jsxElement: JSX.Element,
  setLoadingPDF: React.Dispatch<React.SetStateAction<boolean>>
) => {
  let url: string
  try {
    setLoadingPDF(true)
    const blob = await pdf(jsxElement).toBlob()
    url = URL.createObjectURL(blob)
    window.open(url, '_blank', 'noopener,noreferrer')

  } catch (e) {
    console.log(e)
  } finally {
    setLoadingPDF(false)
    setTimeout(() => URL.revokeObjectURL(url), 60_000)
  }
}

export const toBase64Image = async (url: string): Promise<string> => {
  const response = await fetch(url)
  const blob = await response.blob()

  return await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}
